import { createSlice } from '@reduxjs/toolkit';

import {
    BULK_UPDATE_ITEMS,
    BULK_UPDATE_ITEMS_FAILURE,
    BULK_UPDATE_ITEMS_SUCCESS,
    DUPLICATE_PRODUCT,
    DUPLICATE_PRODUCT_FAILURE,
    DUPLICATE_PRODUCT_SUCCESS,
    FETCH_PRODUCTS,
    FETCH_PRODUCTS_FAILURE,
    FETCH_PRODUCTS_SUCCESS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    bulkUpdateItems: { errors: [], isFetching: false },
    duplicateProduct: { errors: [], isFetching: true },
    products: {
        data: { data: [], paginaton: {} },
        errors: [],
        isFetching: false,
    },
};

const financialSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [BULK_UPDATE_ITEMS]: (state) => {
            state.bulkUpdateItems.isFetching = true;
        },
        [BULK_UPDATE_ITEMS_FAILURE]: (state, action) => {
            state.bulkUpdateItems = {
                ...state.bulkUpdateItems,
                isFetching: false,
                errors: action.payload,
            };
        },
        [BULK_UPDATE_ITEMS_SUCCESS]: (state) => {
            state.bulkUpdateItems.isFetching = false;
        },
        [DUPLICATE_PRODUCT]: (state) => {
            state.duplicateProduct.isFetching = true;
        },
        [DUPLICATE_PRODUCT_FAILURE]: (state, action) => {
            state.duplicateProduct = {
                ...state.duplicateProduct,
                isFetching: false,
                errors: action.payload,
            };
        },
        [DUPLICATE_PRODUCT_SUCCESS]: (state) => {
            state.duplicateProduct.isFetching = false;
        },
        [FETCH_PRODUCTS]: (state) => {
            state.products.isFetching = true;
        },
        [FETCH_PRODUCTS_FAILURE]: (state, action) => {
            state.products = {
                ...state.products,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_PRODUCTS_SUCCESS]: (state, action) => {
            state.products = {
                ...state.products,
                data: action.payload,
                isFetching: false,
            };
        },
    },
});

export const financialActions = financialSlice.actions;

export default financialSlice.reducer;
